export const needShowTeams = (conditionFieldId: string): boolean => {
  return !conditionFieldId.includes("outlook-email");
};
